import React from 'react';
import Icon from '../../../components/AppIcon';

const PricingInfo = () => {
  const features = [
    {
      icon: 'Search',
      title: 'Free Candidate Search',
      description: 'Browse unlimited anonymous profiles with advanced filters'
    },
    {
      icon: 'Eye',
      title: 'Profile Preview',
      description: 'See skills, experience, and match percentage before unlocking'
    },
    {
      icon: 'CreditCard',
      title: 'Pay Per Unlock',
      description: 'Only pay 149 NOK when you find the right candidate'
    },
    {
      icon: 'MessageCircle',
      title: 'Direct Contact',
      description: 'Get full contact details and start conversations immediately'
    },
    {
      icon: 'Users',
      title: 'Team Collaboration',
      description: 'Share profiles and notes with your hiring team'
    },
    {
      icon: 'Bookmark',
      title: 'Saved Searches',
      description: 'Save search criteria and get email alerts for new matches'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-2xl p-8 border border-primary/10">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-2xl mb-4">
          <Icon name="Briefcase" size={32} className="text-primary" />
        </div>
        <h2 className="text-2xl font-semibold text-foreground mb-2">
          Transparent Pricing Model
        </h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          Search for free, pay only when you find the perfect candidate
        </p>
      </div>
      <div className="bg-card rounded-xl p-6 mb-8 border border-border">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Profile Unlock</h3>
            <p className="text-sm text-muted-foreground">
              Get full candidate contact information
            </p>
          </div>
          <div className="text-right">
            <div className="text-3xl font-bold text-primary">149 NOK</div>
            <div className="text-sm text-muted-foreground">per candidate</div>
          </div>
        </div>
        
        <div className="flex items-center space-x-2 text-sm text-success">
          <Icon name="Check" size={16} />
          <span>No subscription fees • No hidden costs • Pay as you go</span>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4 mb-8">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={feature?.icon} size={16} className="text-primary" />
            </div>
            <div>
              <h4 className="font-medium text-foreground text-sm">{feature?.title}</h4>
              <p className="text-xs text-muted-foreground">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-success/5 rounded-lg p-4 border border-success/20">
        <div className="flex items-start space-x-3">
          <Icon name="Shield" size={20} className="text-success mt-0.5" />
          <div>
            <h4 className="font-medium text-foreground text-sm mb-1">
              GDPR Compliant & Secure
            </h4>
            <p className="text-xs text-muted-foreground">
              All data is encrypted and stored securely. Full compliance with Norwegian and EU privacy regulations.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingInfo;